import React from 'react';
import { AppCustomProps, defaultCustomProps } from '..';

export const CustomPropsContext = React.createContext<AppCustomProps>(defaultCustomProps);

export const CustomPropsProvider = CustomPropsContext.Provider;
